export default __webpack_public_path__ + "static/media/SIW200G_M070_75_80_90_105_W1.c499e48a.webp";